<template>
  <!-- 省市区 -->
  <div class="left-menu" ref="leftMenu">
    <!-- 舆情分析 -->
    <div class="inside" v-if="$route.meta.pageType === 0">
      <div class="left-fang">
        <div class="btn-warp clearfix">
          <router-link class="fl" :to="{ path: '' + $parent.baseUrl + '/buildSolution' }"><button
              class="btn build btn-jbblue"><i class="icons add-icon"></i>新建</button></router-link>
          <button class="btn switch btn-border-blue fr" @click="selectPlan();">切换方案</button>
        </div>
        <!-- <router-link class="text ovhidden clearfix db" :to="{path:''+$parent.baseUrl+'/buildSolution',query:{'planId':$parent.isPlan.id}}" v-if="$parent.isPlan!= ''"><i class="icons fa-icon fl"></i>{{$parent.isPlan.name}}</router-link> -->
        <div class="text clearfix" v-if="$parent.isPlan != ''">
          <i class="icons fa-icon fl"></i>
          <router-link class="href fr"
            :to="{ path: '' + $parent.baseUrl + '/buildSolution', query: { 'planId': $parent.isPlan.id } }"
            title="编辑当前方案"><i class="icons edit-icon3"></i></router-link>
          <a class="href fr" href="javascript:void(0);" @click="openKeywordsMatching();" title="选择查看范围"><i
              class="icons select-icon"></i></a>
          <span class="ovhidden db" :title="$parent.isPlan.name">{{ $parent.isPlan.name }}</span>
        </div>
      </div>
      <ul class="naver">
        <li v-for="(item, index) in leftMenu" :key="index">
          <router-link class="db" :class="$route.meta.shuYu === item.include ? 'router-link-active' : ''"
            :to="{ path: $baseUrl + item.url }"><i class="icons fl" :class="item.icon"></i>{{ item.name }}</router-link>
        </li>
        <!-- <li>
                    <router-link class="db" :to="{path:''+$parent.baseUrl+'/informationSet'}"><i class="icons nav-icon2 fl"></i>信息汇总</router-link>
                </li>
                <li>
                    <router-link class="db" :class="$route.meta.shuYu === 'propagationAnalysis' ? 'router-link-active' : ''" :to="{path:''+$parent.baseUrl+'/allAnalysis?type=total'}"><i class="icons nav-icon3 fl"></i>传播分析</router-link>
                </li>
                <li>
                    <router-link class="db" :class="$route.meta.shuYu === 'yuJinCenter' ? 'router-link-active' : ''" :to="{path:''+$parent.baseUrl+'/yuJinCenter'}"><i class="icons nav-icon4 fl"></i>自动预警</router-link>
                </li>
                <li>
                    <router-link class="db" :class="$route.meta.shuYu === 'presentation' ? 'router-link-active' : ''" :to="{path:''+$parent.baseUrl+'/presentationCenter'}"><i class="icons nav-icon5 fl"></i>报告中心</router-link>
                </li>
                <li>
                    <router-link class="db" :to="{path:''+$parent.baseUrl+'/sourceCenter'}"><i class="icons nav-source fl"></i>信源中心</router-link>
                </li>
                <li>
                    <router-link class="db" :to="{path:''+$parent.baseUrl+'/intelligenceYuJin'}"><i class="icons nav-zhineng fl"></i>智能预警</router-link>
                </li> -->
      </ul>
    </div>
    <!-- 个人中心 -->
    <div class="inside" v-if="$route.meta.pageType === 4">
      <div class="personal-rank color-8a8a99">
        <img class="img db"
          :src="$parent.headImg === '' ? '' + $parent.baseUrl + '/static/images/headImg.png' : $parent.headImg"
          :onerror="defaultHeadImg" />
        <div class="user-name mt20 ac">{{ $parent.nickname }}</div>
        <div class="rank ac"><i class="icons" :class="vipIcons[$parent.memberType - 1]"
            v-if="$parent.memberType != 0 && $parent.memberType * 1 < 5"></i>{{ $parent.memberTypeName }}</div>
        <div class="rank ac"><span class="color-white">{{ $parent.expireTime }}到期</span></div>
        <div class="rank ac">剩余短信数：<span class="color-white">{{ $parent.remainSmsNum }}</span> 条</div>
        <div class="rank ac">剩余下载量：<span class="color-white">{{ $parent.remainDownloadNum }}</span> 条</div>
        <div class="rank ac">剩余互动量：<span class="color-white">{{ $parent.remainRefreshNum }}</span> 条</div>
      </div>
      <ul class="naver">
        <li v-for="(item, index) in userCenterMenuList" :key="index">
          <router-link v-if="item.name != '账户中心' && item.name != '退出登录'" class="db"
            :class="$route.meta.shuYu === item.include ? 'router-link-active' : ''"
            :to="{ path: '' + $parent.baseUrl + item.path }"><i class="icons fl" :class="item.icon"></i>{{ item.name
            }}</router-link>
        </li>
        <!-- <li>
                    <router-link class="db" :class="$route.meta.shuYu === 'vip' ? 'router-link-active' : ''" :to="{path:''+$parent.baseUrl+'/vipRight'}"><i class="icons nav-icon6 fl"></i>我的会员</router-link>
                </li>
                <li>
                    <router-link class="db" :to="{path:''+$parent.baseUrl+'/myCollect'}"><i class="icons nav-icon7 fl"></i>我的收藏</router-link>
                </li>
                <li>
                    <router-link class="db" :to="{path:''+$parent.baseUrl+'/myDownload'}"><i class="icons nav-icon8 fl"></i>我的下载</router-link>
                </li>
                <li>
                    <router-link class="db" :to="{path:''+$parent.baseUrl+'/receiveSet'}"><i class="icons nav-icon12 fl"></i>我的联系人</router-link>
                </li>
                <li>
                    <router-link class="db" :to="{path:''+$parent.baseUrl+'/feedback'}"><i class="icons nav-icon13 fl"></i>在线反馈</router-link>
                </li>
                <li>
                    <router-link class="db" :to="{path:''+$parent.baseUrl+'/systemSettings'}"><i class="icons setup-icon fl"></i>系统设置</router-link>
                </li>
                <li>
                    <router-link class="db" :to="{path:''+$parent.baseUrl+'/addData'}"><i class="icons bulu fl"></i>数据补录</router-link>
                </li> -->
      </ul>
    </div>
    <!-- 热点事件 -->
    <div class="inside mt20" v-if="$route.meta.pageType === 2">
      <ul class="naver">
        <li>
          <router-link class="db" :to="{ path: '' + $parent.baseUrl + '/eventsIndex' }"><i
              class="icons nav-icon9 fl"></i>事件首页</router-link>
        </li>
        <li>
          <router-link class="db" :to="{ path: '' + $parent.baseUrl + '/eventsKu' }"><i
              class="icons nav-icon10 fl"></i>事件库</router-link>
        </li>
        <li>
          <router-link class="db" :to="{ path: '' + $parent.baseUrl + '/specialKu' }"
            :class="$route.meta.shuYu === 'eventSpecia' ? 'router-link-active' : ''"><i
              class="icons nav-icon11 fl"></i>专题库</router-link>
        </li>
      </ul>
    </div>
    <!-- 选择方案 -->
    <Dialog ref="planModal" type="normal" width="776" title="选择方案" :modalFoot="false">
      <div slot="mdBox">
        <vue-scroll :ops="ops" style="width:100%;height:420px">
          <div class="search-warp clearfix">
            <button class="search-btn fr"><i class="icons search-icon"></i></button>
            <div class="hidden"><input class="input-text" v-model="searchQuery" type="text" placeholder="请输入方案名称进行搜索" />
            </div>
          </div>
          <div class="plan-list mt20">
            <div class="item" v-for="(item, index) in planShowList" :key="index">
              <p class="title">
                <strong class="tion">{{ item.typeName }}</strong>
                <a class="icons edit-icon1 tion" href="javascript:void(0);" @click="editPlanClassification(index);"></a>
                <a class="icons del-sm-icon tion" href="javascript:void(0);"
                  @click="delPlanClassification(index, item.typeId);"></a>
              </p>
              <ul class="plan-ul clearfix">
                <li v-for="(items, index) in item.schemeList" :key="index"
                  :class="items.id === $parent.isPlan.id ? 'curr' : ''" @click="enterPlan(items.id, items.name);">
                  <div class="caozu fr">
                    <a class="icons edit-icon1" href="javascript:void(0);" @click.stop="editPlan(items.id);"></a>
                    <a class="icons del-sm-icon" href="javascript:void(0);" @click.stop="delPlan(items.id);"></a>
                  </div>
                  <span class="name ovhidden">{{ items.name }}</span>
                </li>
              </ul>
            </div>
          </div>
        </vue-scroll>
      </div>
    </Dialog>
    <!-- 删除提示 -->
    <Dialog ref="delPlanModal" :callback="enterDelPlan" type="confirm">
      <div slot="mdBox">
        <p class="ac">是否删除此方案</p>
      </div>
    </Dialog>
    <!-- 修改分类 -->
    <Dialog ref="shieldModalFn" title="编辑方案分类" :callback="shieldModal" width="400">
      <div slot="mdBox">
        <input class="input-text" v-model="planNameType" maxlength="7" type="text" placeholder="请输入分类名称（最多7个字）" />
      </div>
    </Dialog>
    <!-- 当前方案关键词选择 -->
    <Dialog ref="keywordsMatch" title="选择关键词" :callback="keywordsMatching" type="normal" width="600">
      <div slot="mdBox">
        <div class="checkbox-group nolike clearfix"
          v-if="$parent.isPlan.keywordsMain && $parent.isPlan.keywordsMain.length > 0">
          <div class="dif flex-alicent">
            <label class="checkbox-warp fl  mr10" :class="allMainList.indexOf('主体词') != -1 ? 'curr' : ''">
              <input name="" v-model="allMainList" value="主体词" type="checkbox" @change="allCheck(1)" class="checkbox">
              <i class="icons checkbox-icon"></i>
            </label>
            <p style="clear:both;height:30px;line-height:30px;width:500px;">主体词：</p>
          </div>
          <label class="checkbox-box" v-for="(item, index) in $parent.isPlan.keywordsMain" :key="index">
            <label class="checkbox-warp fl" :class="keywordsMainSelect.indexOf(item) != -1 ? 'curr' : ''"><input name=""
                v-model="keywordsMainSelect" type="checkbox" :value="item" class="checkbox"> <i
                class="icons checkbox-icon"></i></label>
            <div class="hidden ac">{{ item }}</div>
          </label>
        </div>
        <div class="checkbox-group nolike clearfix"
          v-if="$parent.isPlan.keywordsFinal && $parent.isPlan.keywordsFinal.length > 0">
          <div class="dif flex-alicent">
            <label class="checkbox-warp fl  mr10" :class="allMainList.indexOf('分析词') != -1 ? 'curr' : ''">
              <input name="" v-model="allMainList" value="分析词" type="checkbox" @change="allCheck(2)" class="checkbox">
              <i class="icons checkbox-icon"></i>
            </label>
            <p style="clear:both;height:30px;line-height:30px;width:500px;">分析词：</p>
          </div>
          <label class="checkbox-box" v-for="(item, index) in $parent.isPlan.keywordsFinal" :key="index">
            <label class="checkbox-warp fl" :class="keywordsSelect.indexOf(item) != -1 ? 'curr' : ''"><input name=""
                v-model="keywordsSelect" type="checkbox" :value="item" class="checkbox"> <i
                class="icons checkbox-icon"></i></label>
            <div class="hidden ac">{{ item }}</div>
          </label>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Dialog from './dialog.vue';
import { mapState } from 'vuex';
export default {
  components: { Dialog },
  name: "left",
  props: '',
  data() {
    return {
      allMainList: [],
      ops: {
        vuescroll: {},
        scrollPanel: {},
        rail: {
          keepShow: true
        },
        bar: {
          hoverStyle: true,
          onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
          background: '#c4c4cc',
        }
      },
      searchQuery: '',//方案关键词搜索
      editPlanIndex: '',//需要操作的方案
      planNameType: '',
      delId: '',//方案删除的ID
      pageType: 2, //0是舆情分析 1是产品市场 2是热点事件 3是帮助文档 4是个人中心
      vipIcons: ['rank-icon4', 'rank-icon1', 'rank-icon3', 'rank-icon5', '', '', ''],//会员等级对照表
      planList: [],//方案列表
      planShowList: [],//方案显示列表
      delReptId: '',//竞对方案删除的ID
      reportPlanType: [],//所选竞对方案
      opsHeight: '',
      isCreatePlan: false,//判断点击的竞对方案是否改变
      defaultHeadImg: 'this.src="' + '' + this.$parent.baseUrl + '/static/images/headImg.png' + '"',//默认用户头像
      keywordsSelect: [],//方案关键词选择
      keywordsMainSelect: []//方案主体词选择
    }
  },
  computed: {
    ...mapState({
      leftMenu: state => state.show.leftMenu,
      userCenterMenuList: state => state.show.userCenterMenuList
    })
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        let kf = document.querySelector('#icon_module')
        if (kf.style != null) {
          kf.style.display = 'none';
        }
      }, 100)
    })

    let that = this;
    that.opsHeight = that.$refs.leftMenu.offsetHeight - 81;
    if (that.$route.meta.pageType == 5) {
      that.reportPlanAjax();
    }
    setTimeout(() => {
      // console.log(this.leftMenu)
    }, 5000)
  },
  watch: {
    searchQuery(val) {
      this.searchPlan(val);
    },
    $route() {
      let that = this;
      if (that.$route.meta.pageType == 5) {
        that.reportPlanAjax();
      }
    },
    keywordsMainSelect: {
      handler(n, o) {
        if (!this.$parent.isPlan.keywordsMain) return
        if (n.length == this.$parent.isPlan.keywordsMain.length && this.allMainList.indexOf('主体词') == -1) {
          this.allMainList.push('主体词')
        } else if (n.length !== this.$parent.isPlan.keywordsMain.length) {
          this.$delete(this.allMainList, this.allMainList.indexOf('主体词'))
        }
      },
      immediate: true
    },
    keywordsSelect: {
      handler(n, o) {
        if (!this.$parent.isPlan.keywordsFinal) return
        if (n.length == this.$parent.isPlan.keywordsFinal.length && this.allMainList.indexOf('分析词') == -1) {
          this.allMainList.push('分析词')
        } else if (n.length !== this.$parent.isPlan.keywordsFinal.length) {
          this.$delete(this.allMainList, this.allMainList.indexOf('分析词'))
        }
      },
      immediate: true
    },
  },
  methods: {
    allCheck(val) {
      if (val == 1) {
        if (this.allMainList.indexOf('主体词') !== -1) this.$set(this, 'keywordsMainSelect', [...this.$parent.isPlan.keywordsMain])
        else this.$set(this, 'keywordsMainSelect', [])
      } else {
        if (this.allMainList.indexOf('分析词') !== -1) this.$set(this, 'keywordsSelect', [...this.$parent.isPlan.keywordsFinal])
        else this.$set(this, 'keywordsSelect', [])
      }
    },
    // 获取方案列表
    getPlanList() {
      let that = this;
      that.$parent.loadModal(true, '正在获取数据');
      that.$api.get('monitor/scheme/list', null, r => {
        that.$parent.returnCode(r, function () {
          that.$parent.showLoad = false;
          that.planList = r.data;
          that.searchPlan(that.searchQuery);
          that.$refs.planModal.showMaskFun();
        });
      })
    },
    // 选择方案
    selectPlan() {
      let that = this;
      that.getPlanList();
    },
    // 确定方案
    enterPlan(id, name) {
      let that = this;
      let value = {
        id: id,
        name: name
      };
      that.$api.get('monitor/scheme/change', { id: id }, r => {
        that.$parent.returnCode(r, function () {
          that.planList = r.data;
          that.$refs.planModal.closeMask();
          that.resetSetItem('planStorage', JSON.stringify(value));
          if (that.$route.path === '/buildSolution' || that.$route.path === '/vindex/buildSolution') {
            that.$router.push({ path: that.$baseUrl + '/buildSolution', query: { planId: id } });
            window.location.reload();
          } else {
            window.location.reload();
          }
        });
      })
    },
    // 删除方案
    delPlan(id) {
      let that = this;
      that.delId = id;
      that.$refs.delPlanModal.showMaskFun();
    },
    // 确认删除
    enterDelPlan() {
      let that = this;
      that.$parent.loadModal(true, '正在提交数据...');
      that.$api.post('monitor/scheme/delete', { id: that.delId }, r => {
        that.$parent.returnCode(r, function () {
          that.$parent.showLoad = false;
          that.$utils.alertText('删除成功');
          if (that.$parent.isPlan.id == that.delId) {//删除的方案是当前方案会刷新页面
            location.reload();
            return;
          }
          if (r.data.length === 0) {//方案全部删除完
            that.$parent.getCurrplan();
            that.$refs.planModal.closeMask();
            return;
          }
          that.planList = r.data;
          that.searchPlan(that.searchQuery);
          that.$refs.delPlanModal.closeMask();
          that.$refs.planModal.showMaskFun();
        });
      })
    },
    // 添加方案分类
    editPlanClassification(index) {
      let that = this;
      that.editPlanIndex = index;
      let currArr = that.planList[index];
      that.planNameType = currArr.typeName;
      that.$refs.shieldModalFn.showMaskFun();
    },
    // 确认添加方案分类
    shieldModal() {
      let that = this;
      if (that.planNameType == '') {
        that.$utils.alertText('方案分类不能为空');
        return;
      }
      let id = that.planList[that.editPlanIndex].typeId;
      let data = {
        name: that.planNameType,
        id: id
      }
      that.$parent.loadModal(true, '正在提交数据...');
      that.$api.post('monitor/scheme-type/update', { data: data }, r => {
        that.$parent.showLoad = false;
        that.$parent.returnCode(r, function () {
          let data = r.data;
          that.planList[that.editPlanIndex].typeName = r.data.name;
          that.$refs.shieldModalFn.closeMask();
        });
      });
    },
    // 修改方案
    editPlan(id) {
      this.$refs.planModal.closeMask();
      this.$router.push({ path: '' + this.$parent.baseUrl + '/buildSolution', query: { planId: id } })
    },
    // 删除方案分类
    delPlanClassification(index, id) {
      let that = this;
      let list = that.planShowList;
      let len = list[index].schemeList.length;
      if (len > 0) {
        that.$utils.alertText('此分类包含方案，不能删除！');
        return;
      }
      that.$confirm('是否删除此分类？').then(() => {
        let data = {
          id: id
        }
        that.$parent.loadModal(true, '正在删除...');
        that.$api.post('monitor/scheme-type/del', { data: data }, r => {
          that.$parent.showLoad = false;
          that.$parent.returnCode(r, function () {
            that.$utils.alertText('删除成功！');
            list.splice(index, 1);

          })
        })
      })
    },
    // 打开方案多个关键词组的匹配信息弹框
    openKeywordsMatching() {
      let that = this;
      if (this.$parent.isPlan.keywordsSelect) {
        this.keywordsSelect = [...this.$parent.isPlan.keywordsSelect];
      }
      if (this.$parent.isPlan.keywordsMainSelect) {
        this.keywordsMainSelect = [...this.$parent.isPlan.keywordsMainSelect];
      }
      this.$refs.keywordsMatch.showMaskFun();
    },
    // 方案多个关键词组的匹配信息
    keywordsMatching() {
      let that = this;
      if (this.keywordsMainSelect.length == 0 && this.$parent.isPlan.keywordsMain && this.$parent.isPlan.keywordsMain.length != 0) {
        this.$utils.alertText('请至少选择一个主题词')
        return
      }
      if (this.keywordsSelect.length == 0 && this.$parent.isPlan.keywordsFinal && this.$parent.isPlan.keywordsFinal.length != 0) {
        this.$utils.alertText('请至少选择一个分析词')
        return
      }
      that.$parent.loadModal(true, '正在提交数据...');
      let datas = {
        sid: that.$parent.isPlan.id,
        keywordsSelect: that.keywordsSelect,
        keywordsMainSelect: that.keywordsMainSelect
      }
      that.$api.post('monitor/scheme/keywords-select', { data: datas }, r => {
        that.$parent.returnCode(r, function () {
          that.$parent.showLoad = false;
          that.$utils.alertText('设置成功');
          location.reload();
        });
      })
    },
    // 搜索方案
    searchPlan(val) {
      let that = this;
      if (val == '') {
        that.planShowList = that.planList;
      } else {
        let planList = that.planList;
        let schemeList = [];
        for (let i of planList) {
          let num = 0;
          let arr1 = [];
          for (let j of i.schemeList) {
            num++;
            let name = j.name;
            if (name.indexOf(val) != -1) {
              if (num === 1) {

              }
              arr1.push(j)
            }

          }
          if (arr1 != '') {
            schemeList.push({
              'typeName': i.typeName,
              'schemeList': arr1
            })
          }
        }
        that.planShowList = schemeList;
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/left.vue